"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ErrorIcon_1 = __importDefault(require("../../icons/ErrorIcon"));
const InfoIcon_1 = __importDefault(require("../../icons/InfoIcon"));
const WarningIcon_1 = __importDefault(require("../../icons/WarningIcon"));
const SuccessIcon_1 = __importDefault(require("../../icons/SuccessIcon"));
const getValidationMessageIcon = (type) => {
    switch (type) {
        case 'success':
            return (0, jsx_runtime_1.jsx)(SuccessIcon_1.default, {}, void 0);
        case 'error':
            return (0, jsx_runtime_1.jsx)(ErrorIcon_1.default, {}, void 0);
        case 'warning':
            return (0, jsx_runtime_1.jsx)(WarningIcon_1.default, {}, void 0);
        case 'info':
            return (0, jsx_runtime_1.jsx)(InfoIcon_1.default, {}, void 0);
        default:
            return null;
    }
};
exports.default = getValidationMessageIcon;
